// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

export const AccentGemFragmentDoc = `
    fragment accentGem on CatalogueAccentGem {
  __typename
  id
  quantity
  melee {
    caratWeight
    crystal {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    colors {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    clarities {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
}
    `;